module.exports = __webpack_public_path__ + "img/resume-parser.2d926ff4.svg";